import React, { useState } from 'react';

import AccordionItem from './partials/accordion_item';

const Accordion = ({ block }) => {
  const [isStyle4] = useState(block.style_class === 'style-4');

  return (
    <section
      className={`block ${block._template} ${block.css_class_name} ${block.style_class}`}
    >
      <div
        className='container max-w-full'
        style={{
          width: block.container_width ? `${block.container_width}rem` : 'auto',
        }}
      >
        <div
          className='row'
          style={isStyle4 ? { width: '100%', marginInline: 'auto' } : {}}
        >
          {isStyle4 && (block.title || block.text) && (
            <div className='mb-20 text-center'>
              <h3
                className='title'
                style={
                  isStyle4
                    ? {
                        backgroundImage: 'none',
                        justifyContent: 'center',
                        paddingBottom: '20px',
                        cursor: 'auto',
                      }
                    : {}
                }
              >
                {block.title}
              </h3>
              <p
                className='content'
                style={
                  isStyle4
                    ? {
                        backgroundImage: 'none',
                        justifyContent: 'center',
                      }
                    : {}
                }
              >
                {block.text}
              </p>
            </div>
          )}

          <div
            className='col-acc'
            style={
              isStyle4
                ? {
                    margin: 0,
                    padding: 0,
                    width: '100%',
                    marginInline: 'auto',
                  }
                : {}
            }
          >
            <div className='accordion-wr'>
              {block.accordion.map((item, index) => {
                return (
                  <AccordionItem
                    key={index}
                    item={item}
                    isStyle4={isStyle4}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accordion;
